<template>
  <card class="card-stats" :show-footer-line="true" >
    <b-row>

      <b-col>
        <slot>
          <h1 style=font-size:60px class=" text-dark mb-0" v-if="subTitle">{{subTitle}}</h1>
          <h3 class="card-title text-uppercase text-dark mb-0" v-if="title">{{title}}</h3>
        </slot>
      </b-col>

      <b-col cols="auto" v-if="$slots.icon || icon">
        <slot name="icon" >
          <div class="icon icon-shape text-white rounded-circle shadow"
               :class="[`bg-${type}`, iconClasses]">
            <i :class="icon" ></i>
          </div>
        </slot>
      </b-col>
    </b-row>

    <p class="mt-3 mb-0 text-sm">
      <slot name="footer">

      </slot>
    </p>
  </card>
</template>
<script>
  import Card from './Card.vue';

  export default {
    name: 'stats-card2',
    components: {
      Card
    },
    props: {
      type: {
        type: String,
        default: 'primary'
      },
      icon: String,
      title: String,
      subTitle: String,
      iconClasses: [String, Array]
    }
  };
</script>
<style></style>
